// import AOS from 'AOS'
$(function() {
  AOS.init();
});
